import { render, staticRenderFns } from "./subscription-category-form.vue?vue&type=template&id=798b28ac&scoped=true&"
import script from "./subscription-category-form.vue?vue&type=script&lang=ts&"
export * from "./subscription-category-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798b28ac",
  null
  
)

export default component.exports